<template>
  <DialogConfirmation ref="dialogConfirmation"/>
  <div class="row">
    <div class="col">
      <DataTable
          class="p-datatable-sm"
          :value="endroits"
          :resizableColumns="true"
          columnResizeMode="fit"
          :reorderableColumns="true"
          dataKey="cle"
          :paginator="true"
          :rows="10"
          sort-field="cle"
          :sortOrder="-1"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          :rowsPerPageOptions="[10, 30, 100]"
          currentPageReportTemplate="Afficher {first} de {last} sur {totalRecords} endroits"
      >
        <template #empty>
          <div v-if="isRechercheDataLoading == true" class="row">
            <div class="col">
              <vue-loaders name="ball-beat" class="justify-center"></vue-loaders>
            </div>
          </div>
          <div v-else class="row">
            &nbsp;&nbsp;&nbsp;Aucun enregistrement retourné
          </div>
        </template>
        <Column
            field="cle"
            header="Endroit"
            :sortable="true"
        ></Column>
        <Column
            field="entite"
            header="Entité"
            :sortable="true"
        ></Column>
        <Column
            field="site"
            header="Site"
            :sortable="true"
        ></Column>
        <Column
            field="description"
            header="Description"
            :sortable="true"
        ></Column>
        <Column
            field="regroupementEndroit"
            header="Regroupement des endroits"
            :sortable="true"
        ></Column>
        <Column headerStyle="width: 8rem" :exportable="false">
          <template #body="slotProps">
            <div class="row">
              <div class="col">
                <Button
                    icon="pi pi-save"
                    class="p-button-datatable p-button-rounded-sm"
                    @click="sauvegarder(slotProps.data)"
                />
              </div>
              <div class="col">
                <Button
                    icon="pi pi-trash"
                    class="p-button-datatable p-button-rounded-sm"
                    @click="confirmerSuppression(slotProps.data)"
                />
              </div>
            </div>
          </template>
        </Column>
      </DataTable>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import axios from 'axios';
import DialogConfirmation from '../../../Commun/DialogConfirmation.vue';

export default {
  props: ['endroits', 'isRechercheDataLoading'],
  emits: ['removeEndroitFromList'],
  components: {
    DialogConfirmation
  },
  mounted() {
    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
  },
  data() {
    return {
      endroitToDelete : null
    }
  },
  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
    }),
  },
  methods: {
    sauvegarder(data){
      this.$store.commit('pilotage/ENDROIT_TO_UPDATE', data);
      console.log(data);
      this.$router.push({name: "modifierEndroit", params: {cle:data.cle}});
    },
    confirmerSuppression(data) {
      this.endroitToDelete = data.cle
      this.$confirm.require({
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        message: "Voulez-vous supprimer l'endroit?",
        accept: this.supprimer,
        reject: () => {},
      })
    },
    supprimer() {
      this.$store.dispatch('pilotage/supprimerEndroitAction', {cle: this.endroitToDelete}).then(() => {
        this.$toast.add({
          severity:'success',
          summary: 'Suppression Endroit',
          detail:"La suppression a été effectuée",
          life: 6000
        });
        this.$emit("removeEndroitFromList", this.endroitToDelete);
      });
    },
  }
}
</script>
